// Lookups owned by the Contact Info tab. Kept apart from queries.ts so the tab can evolve on its own.
import { buildPagingLiteral, buildWhereLiteral } from '@/lib/graphql-query-builder';

/**
 * Cantons / divisions / districts / states of the active organization. Legacy served them from `v1/location`,
 * which is the Location schema here, not RegionalPlace (that one only backs hard-coded place lists).
 */
export const buildGetContactCantonsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Locations: getLocations(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        State
      }
    }
  }
`;
